import { LOADING, STATUS_CODE_SUCCESS } from "../../constants/constant";
import {
  UPDATE_BRAND_SUCCESS,
  UPDATE_BRAND_REQUESTED,
  UPDATE_BRAND_FAILED,
  RESET_STATE,
} from "../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: false,
};
export default function updateBrandReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_BRAND_REQUESTED:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case UPDATE_BRAND_SUCCESS:
      let userRes = Object.assign({}, state);
      console.log(
        "came to the updateBrandReducer success   " + JSON.stringify(action)
      );
      userRes.status = action.data.status_message;
      userRes.statusCode = action.data.status_code;
      if (userRes.statusCode !== STATUS_CODE_SUCCESS) {
        userRes.error = true;
        userRes.errorMessage = action.data.message;
        return userRes;
      }
      userRes.data = action.data.data;
      userRes.error = false;
      return userRes;

    case UPDATE_BRAND_FAILED:
      return Object.assign({}, state, action.error);

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
}
